(function () {
  var MOBILE_MAX_WIDTH = 768;

  function isMobile() {
    return window.innerWidth <= MOBILE_MAX_WIDTH;
  }

  // Zoom/lightbox is for PDP only — collection quick-view should be slider-only
  function shouldEnableModalZoom() {
    var name = (window._template && window._template.name) || '';
    var body = document.body;

    if (
      name === 'collection' ||
      name === 'index' ||
      name === 'page' ||
      name === 'search' ||
      name === 'cart' ||
      (body &&
        (body.classList.contains('template-collection') ||
          body.classList.contains('template-index') ||
          body.classList.contains('template-page')))
    ) {
      return false;
    }

    return (
      name === 'product' || (body && body.classList.contains('template-product'))
    );
  }

  function plainCarouselCellHtml(imageUrl, pinchClass) {
    var imgClass = pinchClass
      ? 'lazyautosizes lazyloaded aex-modal-pinch-image'
      : 'lazyautosizes lazyloaded';

    return (
      '<div class="carousel-cell">' +
      '<img class="' +
      imgClass +
      '" data-flickity-lazyload="' +
      imageUrl +
      '" src="' +
      imageUrl +
      '" data-src="' +
      imageUrl +
      '" alt="">' +
      '</div>'
    );
  }

  function unwrapModalZoomLinks(imageHandle) {
    if (!imageHandle) return;

    imageHandle.querySelectorAll('a.pswp-gallery__item').forEach(function (link) {
      var parent = link.parentNode;
      if (!parent) return;

      while (link.firstChild) {
        parent.insertBefore(link.firstChild, link);
      }
      parent.removeChild(link);
    });
  }

  function wrapModalZoomLinks(imageHandle) {
    if (!imageHandle) return;

    imageHandle.querySelectorAll('.carousel-cell').forEach(function (cell) {
      if (cell.querySelector('a.pswp-gallery__item')) return;

      var img = cell.querySelector('img');
      if (!img) return;

      var src =
        img.getAttribute('data-src') ||
        img.getAttribute('data-flickity-lazyload') ||
        img.currentSrc ||
        img.getAttribute('src');

      if (!src) return;

      var link = document.createElement('a');
      link.className = 'pswp-gallery__item';
      link.href = getZoomImageUrl(src);
      link.setAttribute('data-pswp-width', '2000');
      link.setAttribute('data-pswp-height', '2000');
      link.setAttribute('data-pswp-tile-type', 'deepzoom');

      img.parentNode.insertBefore(link, img);
      link.appendChild(img);
    });
  }

  function enableModalSliderOnly(flkty, imageHandle) {
    if (!imageHandle) return;

    imageHandle.classList.remove('gallery--getting-started');
    imageHandle.removeEventListener('click', window.aexModalGalleryClick, true);
    unwrapModalZoomLinks(imageHandle);
    destroyModalPinchZoom(getFlktyElement(imageHandle) || imageHandle);

    if (flkty) {
      flkty.off('staticClick', window.aexModalFlickityStaticClick);
      flkty.options.draggable = true;
      if (typeof flkty.updateDraggable === 'function') {
        flkty.updateDraggable();
      }
      flkty.reloadCells();
      flkty.resize();
    }
  }

  function getZoomImageUrl(url) {
    if (!url) return url;

    var normalized = url.replace(/\{width\}/g, '2000');

    if (normalized.indexOf('_{width}x.') > -1) {
      return normalized.replace('_{width}x.', '_2000x.');
    }

    return normalized.indexOf('?') > -1 ? normalized + '&width=2000' : normalized + '?width=2000';
  }

  function getFlktyElement(imageHandle) {
    if (!imageHandle) return null;

    if (imageHandle.classList.contains('flickity-enabled') || imageHandle.hasAttribute('data-product-photos')) {
      return imageHandle;
    }

    return imageHandle.querySelector('[data-product-photos]') || imageHandle;
  }

  function resetModalPinchState(flkty) {
    if (!flkty || !flkty.selectedElement) return;

    var image = flkty.selectedElement.querySelector('img');
    if (!image) return;

    image.style.transform = 'scale(1)';
    image.style.transformOrigin = 'center center';
  }

  function destroyModalPinchZoom(imageHandle) {
    if (!imageHandle || !imageHandle._aexHammer) return;

    imageHandle._aexHammer.destroy();
    imageHandle._aexHammer = null;
    imageHandle._aexPinchState = null;

    if (imageHandle._aexPinchChangeHandler && imageHandle._aexFlkty) {
      imageHandle._aexFlkty.off('change', imageHandle._aexPinchChangeHandler);
      imageHandle._aexPinchChangeHandler = null;
      imageHandle._aexFlkty = null;
    }
  }

  window.aexBindModalPinchZoom = function (flkty, imageHandle) {
    if (!isMobile() || !flkty || !imageHandle || typeof Hammer === 'undefined') return;

    var flktyElement = getFlktyElement(imageHandle);
    if (!flktyElement) return;

    destroyModalPinchZoom(flktyElement);

    var hammertime = new Hammer(flktyElement, {
      touchAction: 'pan-y'
    });
    hammertime.get('pinch').set({ enable: true });
    hammertime.get('pan').set({ direction: Hammer.DIRECTION_ALL, threshold: 10 });

    var pinchState = {
      scale: 1,
      lastScale: 1
    };

    flktyElement._aexHammer = hammertime;
    flktyElement._aexPinchState = pinchState;
    flktyElement._aexFlkty = flkty;

    var onSlideChange = function () {
      resetModalPinchState(flkty);
      pinchState.scale = 1;
      pinchState.lastScale = 1;
    };

    flktyElement._aexPinchChangeHandler = onSlideChange;
    flkty.on('change', onSlideChange);

    hammertime.on('pinchstart', function () {
      flkty.options.draggable = false;
      flkty.updateDraggable();
      pinchState.lastScale = 1;
    });

    hammertime.on('pinch', function (ev) {
      var selectedSlide = flkty.selectedElement;
      if (!selectedSlide) return;

      var image = selectedSlide.querySelector('img');
      if (!image) return;

      if (ev.scale < pinchState.lastScale && pinchState.scale > 0.6) {
        pinchState.scale = pinchState.scale - 0.05;
      } else if (ev.scale > pinchState.lastScale) {
        pinchState.scale = pinchState.scale + 0.05;
      }

      var rect = image.getBoundingClientRect();
      if (!rect.width || !rect.height) return;

      var dx = ((ev.center.x - rect.left) / rect.width) * 100;
      var dy = ((ev.center.y - rect.top) / rect.height) * 100;

      image.style.transform = 'scale(' + pinchState.scale + ')';
      image.style.transformOrigin = dx + '% ' + dy + '%';
      pinchState.lastScale = ev.scale;
    });

    hammertime.on('pinchend', function () {
      flkty.options.draggable = true;
      flkty.updateDraggable();
      resetModalPinchState(flkty);
      pinchState.scale = 1;
      pinchState.lastScale = 1;
    });
  };

  window.aexInitModalMobilePinch = function (imageHandle, flkty) {
    if (!isMobile() || !imageHandle) return;

    function tryBind(attempt) {
      var flktyElement = getFlktyElement(imageHandle);
      var instance = flkty || (window.Flickity && Flickity.data(flktyElement));

      if (instance) {
        window.aexBindModalPinchZoom(instance, imageHandle);
        return;
      }

      if (attempt < 20) {
        setTimeout(function () {
          tryBind(attempt + 1);
        }, 50);
      }
    }

    tryBind(0);
  };

  // Always plain cells for Flickity-built modals; zoom wrappers added on PDP via bind
  window.aexModalCarouselCellHtml = function (imageUrl) {
    return plainCarouselCellHtml(imageUrl, shouldEnableModalZoom() && isMobile());
  };

  window.aexPrepareModalGallery = function (imageHandle) {
    if (!imageHandle || isMobile()) return;

    imageHandle.classList.add('gallery--getting-started');
  };

  function openModalLightbox(imageHandle, link) {
    if (!imageHandle || !link || !window.aexPhotoSwipeLightbox || isMobile()) return;

    var links = imageHandle.querySelectorAll('a.pswp-gallery__item');
    var index = Array.prototype.indexOf.call(links, link);

    if (index < 0) return;

    window.aexPhotoSwipeLightbox.loadAndOpen(index, { gallery: imageHandle });
  }

  window.aexModalGalleryClick = function (event) {
    var imageHandle = event.currentTarget;
    var link = event.target.closest('a.pswp-gallery__item');

    if (!link || !imageHandle.contains(link)) return;

    event.preventDefault();
    event.stopPropagation();

    if (isMobile()) return;

    openModalLightbox(imageHandle, link);
  };

  window.aexModalFlickityStaticClick = function (event, pointer, cellElement, cellIndex) {
    if (isMobile()) return;
    if (!cellElement || cellIndex === undefined || cellIndex < 0) return;

    var imageHandle = cellElement.closest('#pjbp-modal-image');
    var link = cellElement.querySelector('a.pswp-gallery__item');

    if (!imageHandle || !link) return;

    event.preventDefault();

    if (window.aexPhotoSwipeLightbox) {
      window.aexPhotoSwipeLightbox.loadAndOpen(cellIndex, { gallery: imageHandle });
    }
  };

  window.aexBindModalGalleryClick = function (imageHandle) {
    if (!imageHandle) return;

    imageHandle.removeEventListener('click', window.aexModalGalleryClick, true);
    imageHandle.addEventListener('click', window.aexModalGalleryClick, true);
  };

  // Strip zoom from product gallery HTML injected into collection modal only
  window.aexDisableModalProductZoom = function (container) {
    if (!container) return;

    container.querySelectorAll('.gallery--getting-started').forEach(function (el) {
      el.classList.remove('gallery--getting-started');
    });

    container.querySelectorAll('[data-product-images], [data-zoom]').forEach(function (el) {
      el.setAttribute('data-zoom', 'false');
    });

    unwrapModalZoomLinks(container);

    container.querySelectorAll('.js-photoswipe__zoom, .product__photo-zoom').forEach(function (btn) {
      btn.remove();
    });

    container.querySelectorAll('img.photoswipe__image').forEach(function (img) {
      img.classList.remove('photoswipe__image');
    });

    container.removeEventListener('click', window.aexModalGalleryClick, true);
  };

  window.aexBindModalFlickityZoom = function (flkty, imageHandle) {
    if (!flkty || !imageHandle) return;

    // Collection page: slider only
    if (!shouldEnableModalZoom()) {
      enableModalSliderOnly(flkty, imageHandle);
      return;
    }

    // Product page: enable zoom / pinch
    flkty.off('staticClick', window.aexModalFlickityStaticClick);
    window.aexBindModalGalleryClick(imageHandle);

    if (isMobile()) {
      imageHandle.classList.remove('gallery--getting-started');
      unwrapModalZoomLinks(imageHandle);
      window.aexBindModalPinchZoom(flkty, imageHandle);
      return;
    }

    wrapModalZoomLinks(imageHandle);
    window.aexPrepareModalGallery(imageHandle);
    flkty.on('staticClick', window.aexModalFlickityStaticClick);
    flkty.reloadCells();
    flkty.resize();
  };

  window.aexInitModalProductGallery = function (imageHandle) {
    if (!imageHandle) return;

    if (!shouldEnableModalZoom()) {
      enableModalSliderOnly(null, imageHandle);
      return;
    }

    window.aexBindModalGalleryClick(imageHandle);

    if (isMobile()) {
      imageHandle.classList.remove('gallery--getting-started');
      window.aexInitModalMobilePinch(imageHandle);
      return;
    }

    var photosContainer = imageHandle.querySelector('[data-product-photos]');

    if (!photosContainer) {
      window.aexPrepareModalGallery(imageHandle);
      return;
    }

    photosContainer.classList.add('gallery--getting-started');

    photosContainer.querySelectorAll('.product-main-slide').forEach(function (slide) {
      if (slide.querySelector('a.pswp-gallery__item')) return;

      var img = slide.querySelector('img');
      if (!img) return;

      var src =
        img.getAttribute('data-photoswipe-src') ||
        img.currentSrc ||
        img.getAttribute('data-src') ||
        img.getAttribute('src');

      if (!src) return;

      var link = document.createElement('a');
      link.className = 'pswp-gallery__item';
      link.href = getZoomImageUrl(src);
      link.setAttribute('data-pswp-width', '2000');
      link.setAttribute('data-pswp-height', '2000');
      link.setAttribute('data-pswp-tile-type', 'deepzoom');

      var imageWrap = img.closest('.image-wrap') || img.parentElement;
      imageWrap.insertBefore(link, img);
      link.appendChild(img);
    });
  };

  document.addEventListener('DOMContentLoaded', function () {
    var modalImage = document.getElementById('pjbp-modal-image');
    if (!modalImage) return;

    if (!shouldEnableModalZoom()) {
      enableModalSliderOnly(null, modalImage);
      return;
    }

    window.aexBindModalGalleryClick(modalImage);
  });
})();
